<template>
  <b-modal
    :hide-footer="true"
    title=""
    centered
    size="md"
    id="verificar-encaminhamento-privado"
    :visible="true"
    :no-close-on-backdrop="true"
    @close="redirectEncaminhamentos"
  >
    <div class="row" v-if="loading">
      <h1 class="col-12 text-center">Verificando sua senha.</h1>
      <load mode="table" />
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12 px-3 text-center">
          <h1>
            Olá, <b v-if="user">{{ user.name }}</b>
          </h1>
          <h3>Encaminhamento com informações sigilosas.</h3>
          <h4>
            Se você é o Técnico Responsável por este Encaminhamento ou foi
            convidado como participante, digite sua senha para acessar o Encaminhamento.
          </h4>
        </div>
        <form-password
          class="mt-3"
          label="Senha de acesso ao sistema"
          placeholder="Digite sua senha"
          v-model="senha"
        />
      </div>

      <div class="row pt-1 px-2 d-flex justify-content-end">
        <button @click="submit" class="btn btn-success btn-submit">
          Acessar
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["familiaId"],
  data() {
    return { senha: "", loading: false, user: "" };
  },
  mounted() {
    axios.get(`api/account/getuser`).then((response) => {
      this.user = response.data;
    });
  },
  methods: {
    submit() {
      this.loading = true;
      axios
        .post(`api/account/verification/password`, { password: this.senha })
        .then((response) => {
          if (response.data.data.message) {
            this.$emit("liberar");
            this.senha = "";
            this.loading = false;
          }
        })
        .catch((error) => {
          this.redirectEncaminhamentos();
        });
    },
    redirectEncaminhamentos() {
      this.$router.push(`/dashboard/encaminhamentos/${this.familiaId}`);
    },
  },
};
</script>
